import { servicesAvailable } from '~/constants/services/objects'
import type { TCommon } from '~/src/types/common'

export const getServiceDataFromRoute = (
  route?: string,
  returnRoute?: string,
) => {
  const [, market] = route.split('/')
  const item = Object.values(servicesAvailable).find((_item) => {
    return _item?.routes?.default?.includes(market)
  })
  if (item) {
    return {
      subscription: item?.subscription,
      route: item?.routes[returnRoute],
    }
  }
  return { subscription: null, route: null }
}

export const MARKET_MAPPING: Record<string, string> = {
  'sustainability-natural-graphite': 'graphite',
  'sustainability-synthetic-graphite': 'graphite',
  'market-assessments-battery-gigafactory': 'battery-and-gigafactory',
  'market-assessments-cathode': 'assessment-precursor',
  'price-assessments-battery-gigafactory': 'battery-cell',
  'forecasts-battery-gigafactory': 'battery-and-gigafactory',
  'price-assessments-recycling': 'black-mass',
  'forecasts-new-technology': 'new-technology',
}

export type TServicesAvailableLike = Record<string, TCommon>
export type TOptionsByGetServicesByRoute = {
  mapping?: Record<string, string>
  services?: TServicesAvailableLike
}

export const getServicesByRoute = (
  route: string,
  options?: TOptionsByGetServicesByRoute,
) => {
  const splits = route.split('/')
  const market = splits[1]
  const typeMarket = splits[3]

  const mapping = options?.mapping ?? MARKET_MAPPING
  const services = options?.services ?? servicesAvailable

  const mappedMarket = mapping[`${typeMarket}-${market}`] || market
  return Object.values(services)
    .filter((_item) => {
      const subscription = _item?.subscription?.split('-').slice(1).join('-')
      return subscription === mappedMarket
    })
    .map((_item) => ({
      subscription: _item?.subscription,
      route: _item?.routes ?? null,
    }))
}

export const hasPricingMenu = (memberships?: object) => {
  return Object.keys(memberships)
    .filter((key) => key.startsWith('pricing'))
    .some((key) => memberships[key] === true)
}
